import React from 'react';
import DayCell from './DayCell';
import { weekdayShort, fmtDateISO, monthName, safeParseDate, typeAccent, typeLabel } from '../utils';

export default function CalendarView({
  granularity,
  daysGrid,
  dayMeta,
  selectedDay,
  setSelectedDay,
  yearMonths,
  setGranularity,
  setCursor,
  filtered,
}) {
  if (granularity === 'month') {
    return (
      <>
        <div className="week">
          {Array.from({ length: 7 }).map((_, i) => <div key={i} className="weekDay">{weekdayShort(i)}</div>)}
        </div>
        <div className="grid">
          {daysGrid.map(({ day, inMonth }, idx) => {
            const key = fmtDateISO(day);
            const meta = dayMeta.get(key);
            const count = meta?.count || 0;
            const dots = meta?.dots || [];
            const sel = day.getFullYear() === selectedDay.getFullYear() && day.getMonth() === selectedDay.getMonth() && day.getDate() === selectedDay.getDate();
            return (
              <DayCell
                key={idx}
                day={day}
                inMonth={inMonth}
                selected={sel}
                count={count}
                dots={dots}
                onClick={() => setSelectedDay(new Date(day.getFullYear(), day.getMonth(), day.getDate()))}
              />
            );
          })}
        </div>
      </>
    );
  }

  return (
    <div className="year">
      {yearMonths.map((m) => {
        const items = filtered.filter((a) => { const d = safeParseDate(a.at); return d.getFullYear() === m.getFullYear() && d.getMonth() === m.getMonth(); });
        const total = items.length;
        const topTypes = Object.entries(items.reduce((acc, a) => { acc[a.type] = (acc[a.type] || 0) + 1; return acc; }, {})).sort((a, b) => b[1] - a[1]).slice(0, 3);
        return (
          <button
            key={m.getMonth()}
            className="yearCard"
            onClick={() => { setGranularity('month'); setCursor(new Date(m.getFullYear(), m.getMonth(), 1)); setSelectedDay(new Date(m.getFullYear(), m.getMonth(), 1)); }}
          >
            <div className="yearTop">
              <div className="yearName">{monthName(m.getMonth())}</div>
              <div className="yearTotal">{total}</div>
            </div>
            <div className="yearTags">
              {topTypes.length ? topTypes.map(([t, n]) => (
                <span key={t} className="yearTag" style={{ '--tag': typeAccent(t) }}>
                  <span className="yearTagDot" />
                  {typeLabel(t)}
                  <span className="yearTagN">{n}</span>
                </span>
              )) : <span className="muted">No events</span>}
            </div>
            <div className="yearHint">Open month</div>
          </button>
        );
      })}
    </div>
  );
}
